import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import style from "./FlexLayout.module.css";
const FORWARD_REF_TYPE = Symbol.for('react.forward_ref');

export default forwardRef(({ children, name, ratio }, ref) => {
    // 使用 React.Children.toArray 将 children 转换为数组
    const childrenArray = React.Children.toArray(children);
    const leftRef = useRef(null);
    const rightRef = useRef(null);
    const adaptRef = (child, ref) => {
        // 检查是否是有效的 React 元素
        if (React.isValidElement(child)) {
            // 检查组件是否是函数组件
            const isForwardRef = child.type.$$typeof === FORWARD_REF_TYPE;
            return React.cloneElement(child, isForwardRef ? { ref } : {});
        }
        return child;
    };
    const leftComponent = adaptRef(childrenArray[0], leftRef);
    const rightComponent = adaptRef(childrenArray[1], rightRef);
    const parentRef = useRef(null);
    const leftDivRef = useRef(null);

    const [vertical, setVertical] = useState(false);

    const [isDragging, setIsDragging] = useState(false); // 拖动状态
    const [middleX, setMiddleX] = useState('0');
    const [middleY, setMiddleY] = useState('0');
    const [leftWidth, setLeftWidth] = useState(ratio||'50%'); // 默认左侧宽度50%
    const [topHeight, setTopHeight] = useState(ratio||'50%'); // 默认右侧宽度50%

    // 使子组件的方法对父组件可用
    useImperativeHandle(ref, () => ({
        updateLayout,
    }));

    const updateLayout = () => {
        if (parentRef.current) {
            const width = parentRef.current.clientWidth;
            const height = parentRef.current.clientHeight;
            if (height / width > 1) {
                setVertical(true);
            } else {
                setVertical(false);
            }
        }
    };

    useEffect(() => {
        // 初始检查
        updateLayout();
        setTimeout(updateLayout, 40);
        // 监听窗口resize事件
        window.addEventListener('resize', updateLayout);
        // 清理函数，防止内存泄漏
        return () => {
            window.removeEventListener('resize', updateLayout);
        };
    }, []);
    useEffect(() => {
        //拖动线及布局处理
        setMiddleY(`${leftDivRef.current.offsetHeight + 12}px`);
        setMiddleX(`${leftDivRef.current.offsetWidth + 12}px`); // 计算垂直中间线的位置

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        window.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('resize', handleResize);
        };
    }, [isDragging]); // 依赖于 isDragging 状态

    useEffect(() => {
        setLeftWidth(ratio || '50%')
        setTopHeight(ratio || '50%')
    }, [ratio])

    //拖动线处理
    const handleMouseDown = (e) => {
        e.preventDefault(); // 防止默认行为
        setIsDragging(true); // 设置拖动状态为 true
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return; // 只有在拖动状态下才执行
        //获取parentRef的left
        let mouseX = e.clientX - parentRef.current.getBoundingClientRect().left;
        let mouseY = e.clientY - parentRef.current.getBoundingClientRect().top;
        let width = parentRef.current.offsetWidth;
        let height = parentRef.current.offsetHeight;

        const newWidth = `calc(${Math.max(0, Math.min(100, (mouseX / width * 100)))}% - 4px)`;
        setLeftWidth(newWidth);
        const newHeight = `calc(${Math.max(0, Math.min(100, (mouseY / height) * 100))}% - 4px)`;
        setTopHeight(newHeight);
        handleResize();
        if (leftRef.current?.updateLayout) {
            leftRef.current.updateLayout()
        }
        if (rightRef.current?.updateLayout) {
            rightRef.current.updateLayout()
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false); // 结束拖动，重置状态
    };

    const handleResize = () => {
        if (leftDivRef.current) {
            setMiddleX(`${leftDivRef.current.offsetWidth + 12}px`);
            setMiddleY(`${leftDivRef.current.offsetHeight + 12}px`);
        }
    };

    return (
        <div className={`${style.playground} ${vertical?style.vertical:style.horizontal}`} ref={parentRef}>
            <div className={`${style.content} ${style.left} ${vertical?style.vertical:style.horizontal}`}
                 ref={leftDivRef}
                 style={{flex: `0 0 ${vertical?topHeight:leftWidth}`, minWidth: '300px', maxWidth: vertical? '100%' : `max(calc(100% - 326px),${ratio||'50%'})`,
                     maxHeight: vertical?`max(calc(85% - 8px), ${ratio||'50%'})`:'100%'
                    }}
            >
                {leftComponent}
            </div>
            {/*拖动线*/}
            <div
                className={`${style.resizeHandle} ${vertical?style.vertical:style.horizontal}`}
                style={{top: middleY, left: middleX}}
                onMouseDown={handleMouseDown}
            >
                <div className={`${style.line} ${vertical?style.vertical:style.horizontal}`}></div>
            </div>
            <div className={`${style.content} ${style.right} ${vertical?style.vertical:style.horizontal}`}>
                {isDragging && <div className={style.mask}></div>}
                {rightComponent}
            </div>
        </div>
    );
});
